(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["erkon-campaign-offer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('erkon-campaign-offer')) {
    customElements.define('erkon-campaign-offer', class extends HTMLElement {
      connectedCallback() {
        this.productInfo = this.closest('product-info');
        this.eligibleIds = new Set(this.dataset.eligibleVariants.split(','));
        this.onVariantChange = (event) => {
          if (event.target.matches('input[name="id"]')) this.updateEligibility(event.target.value);
        };
        this.productInfo?.addEventListener('change', this.onVariantChange);
        const selectedInput = this.productInfo?.querySelector('product-form input[name="id"]');
        if (selectedInput) this.updateEligibility(selectedInput.value);
      }

      disconnectedCallback() {
        this.productInfo?.removeEventListener('change', this.onVariantChange);
      }

      updateEligibility(variantId) {
        const eligible = this.eligibleIds.has(String(variantId));
        this.querySelector('[data-campaign-eligible]').hidden = !eligible;
        this.querySelector('[data-campaign-excluded]').hidden = eligible;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
